import { useState, useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa'; 
import styles from '../EditarPaso.module.css';
import Swal from 'sweetalert2';
import img1 from './images/Valores.png';
import img2 from './images/Logro.png';
import img3 from './images/Autoestima.png';
import img4 from './images/Becas_vigentes.png';
import img5 from './images/FORMATO.png';
import img6 from './images/IMAGEN.png';
import img7 from './images/PRESENTACION.png';
import img8 from './images/Personalidad.png';
import img9 from './images/Solicitar_beca.png';
import img10 from './images/Test.png';
import img11 from './images/Tipos_becas.png';
import img12 from './images/VIDEO.png';
import {useAuth} from '../../../Auth/AuthContext'; 

const EditarSeccion = ({seccionId, onBack, onSeccionUpdated }) => {
    const [formData, setFormData] = useState({
        se_nombre: '',
        se_icono: '',
        se_descripcion: '',
        se_url: '',
        se_archivo: null,
        se_ruta_archivo: '',
        se_tam_archivo: ''
    });

    const {getToken} = useAuth(); 
    const token = getToken(); 

    const [originalData, setOriginalData] = useState({});
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState(null);
    const [tipoArchivo, setTipoArchivo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedIcon, setSelectedIcon] = useState(null);

    const images = [
        { label: 'Valores', src: img1, name: 'Valores.png' },
        { label: 'Logro', src: img2, name: 'Logro.png' },
        { label: 'Autoestima', src: img3, name: 'Autoestima.png' },
        { label: 'Becas vigentes', src: img4, name: 'Becas_vigentes.png' },
        { label: 'Formato', src: img5, name: 'FORMATO.png' },
        { label: 'Imagen', src: img6, name: 'IMAGEN.png' },
        { label: 'Presentación', src: img7, name: 'PRESENTACION.png' },
        { label: 'Personalidad', src: img8, name: 'Personalidad.png' },
        { label: 'Solicitar beca', src: img9, name: 'Solicitar_beca.png' },
        { label: 'Test', src: img10, name: 'Test.png' },
        { label: 'Tipos becas', src: img11, name: 'Tipos_becas.png' },
        { label: 'Video', src: img12, name: 'VIDEO.png' },
    ];

    useEffect(() => {
        if (seccionId) {
            fetchSeccionData();
        }
    }, [seccionId]);

    const parseFileSize = (formattedSize) => {
        if (!formattedSize || formattedSize === '') return null;
        
        // Si ya es un número, devolverlo directamente
        if (typeof formattedSize === 'number') {
            return formattedSize;
        }
        
        // Si es string pero solo contiene números, convertir directamente
        if (typeof formattedSize === 'string' && /^\d+$/.test(formattedSize.trim())) {
            return parseInt(formattedSize.trim(), 10);
        }
        
        // Si es string formateado (ej: "7.5 MB"), convertir de vuelta a bytes
        if (typeof formattedSize === 'string') {
            const trimmed = formattedSize.trim().toUpperCase();
            
            // Extraer número y unidad
            const match = trimmed.match(/^([\d.]+)\s*([KMGT]?B?)$/);
            if (!match) return null;
            
            const value = parseFloat(match[1]);
            const unit = match[2];
            
            // Convertir según la unidad
            switch (unit) {
                case 'B':
                case '':
                    return Math.round(value);
                case 'KB':
                    return Math.round(value * 1024);
                case 'MB':
                    return Math.round(value * 1024 * 1024);
                default:
                    return null;
            }
        }
        
        return null;
    };

    const fetchSeccionData = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/seccion/${seccionId}`, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                }
            });
            const data = await response.json();
            const seccion = data[0];

            if (seccion) {
                const processedData = {
                    se_nombre: (seccion.se_nombre || '').trim(),
                    se_icono: (seccion.se_icono || '').trim(),
                    se_descripcion: (seccion.se_descripcion || '').trim(),
                    se_url: (seccion.se_url || '').trim(),
                    se_archivo: (seccion.se_archivo || '').trim(),
                    se_ruta_archivo: (seccion.se_ruta_archivo || '').trim(),
                    se_tipo_archivo: (seccion.se_tipo_archivo || '').trim(),
                    se_tam_archivo: seccion.se_tam_archivo, // Mantener el valor original
                    se_tam_archivo_formatted: parseFileSize(seccion.se_tam_archivo),
                };
                setFormData(processedData);
                setOriginalData(processedData);
                setTipoArchivo(seccion.se_tipo_archivo);
                if (seccion.se_icono) {
                    const iconoEncontrado = images.find(img => img.name === seccion.se_icono);
                    if (iconoEncontrado) {
                        setSelected(iconoEncontrado);
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
            setError('Error de conexión al cargar la seccion');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const {name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if(errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validar tipo de archivo según el tipo de sección
            const validTypes = {
                'PDF': ['application/pdf'],
                'Ejercicio': ['application/pdf'],
                'video': [], // Para videos se usa URL
                'URL': [] // Para links se usa URL
            };

            if (tipoArchivo === 'PDF' || tipoArchivo === 'Ejercicio') {
                if (!validTypes[tipoArchivo].includes(file.type)) {
                    setError('Solo se permiten archivos PDF para este tipo de sección');
                    return;
                }
            }

            setSelectedFile(file);
            setFormData(prev => ({
                ...prev,
                se_archivo: file
            }));
            
            if (errors.se_archivo) {
                setErrors(prev => ({
                    ...prev,
                    se_archivo: ''
                }));
            }
            setError('');
        }
    };

    const handleIconSelect = (e) => {
        const index = parseInt(e.target.value); // convierte a número
        if (!isNaN(index)) {
            setSelected(index);
            setSelectedIcon(index);
            setFormData(prev => ({
                ...prev,
                se_icono: images[index].name
            }));
        }
        if (errors.se_icono) {
            setErrors(prev => ({
                ...prev,
                se_icono: ''
            }));
        }
    };

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (tipoArchivo === 'URL' || tipoArchivo === 'video'){
            if(!formData.se_url.trim()){
                newErrors.se_url = 'La URL es requerida';
            } else if (!isValidUrl(formData.se_url)) {
                newErrors.se_url = 'Por favor ingresa una URL válida';
            }
        }
        if (tipoArchivo === 'PDF' || tipoArchivo === 'Ejercicio'){
            if(!formData.se_archivo && !selectedFile){
                newErrors.se_archivo = 'El archivo es requerido';
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const getUpdatedFields = () => {
        const updated = {};
        
        Object.keys(formData).forEach(key => {
            if (key !== 'se_archivo') { // El archivo se maneja por separado
                const currentValue = formData[key]?.toString().trim() || '';
                const originalValue = originalData[key]?.toString().trim() || '';
                
                if (currentValue !== originalValue) {
                    updated[key] = currentValue;
                }
            }
        });
        
        return updated;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            setError('Campos incompletos');
            return;
        }

        const updated = getUpdatedFields();
        const hasFileUpdate = selectedFile !== null;
        
        // Verificar si existe un archivo previamente
        const hasExistingFile = originalData.se_archivo && 
                            originalData.se_archivo.toString().trim() !== '';
        
        // Manejar la actualización del icono seleccionado
        const hasIconUpdate = selected !== null && selected !== undefined;
        let iconName = null;
        if (hasIconUpdate) {
            const selectedImage = images[selected];
            iconName = selectedImage?.name;
            
            // Solo agregar se_icono a updated si realmente cambió
            const originalIcon = originalData.se_icono?.toString().trim() || '';
            if (iconName && iconName !== originalIcon) {
                updated.se_icono = iconName;
            }
        }
        
        // Verificar si hay cambios
        if (Object.keys(updated).length === 0 && !hasFileUpdate) {
            setError('No hiciste ningún cambio para actualizar.');
            return;
        }

        setSaving(true);
        
        try {
            setError('');
            const formDataToSend = new FormData();
            
            // Siempre enviar todos los campos que han cambiado
            Object.keys(updated).forEach(key => {
                if (key === 'se_icono') {
                    // Para el icono, enviar como se_icon (lo que espera el backend)
                    formDataToSend.append('se_icono', updated[key]);
                } else {
                    formDataToSend.append(key, updated[key]);
                }
            });

            // Si hay archivo nuevo, agregarlo al FormData
            if (hasFileUpdate) {
                formDataToSend.append('se_archivo', selectedFile);
            } else if (hasExistingFile) {
                // Solo enviar información del archivo existente si NO hay archivo nuevo
                formDataToSend.append('existing_se_archivo', originalData.se_archivo);
                
                // Incluir también ruta y tamaño si existen en originalData
                if (originalData.se_ruta_archivo) {
                    formDataToSend.append('existing_se_ruta_archivo', originalData.se_ruta_archivo);
                } else {
                }
                
                if (originalData.se_tam_archivo && originalData.se_tam_archivo !== 'undefined') {
                    let tamañoNumerico = originalData.se_tam_archivo;
                    tamañoNumerico = parseFileSize(originalData.se_tam_archivo);
                    if (tamañoNumerico !== null) {
                        formDataToSend.append('existing_se_tam_archivo', tamañoNumerico.toString());
                    } else {
                    }
                } else {
                    formDataToSend.append('existing_se_tam_archivo', '');
                }
            }

            // Si no hay cambios en campos de texto pero sí hay archivo nuevo,
            // necesitamos enviar al menos un campo para que el endpoint funcione
            if (Object.keys(updated).length === 0 && hasFileUpdate) {
                // Enviamos el nombre actual (sin cambios) para que pase la validación
                formDataToSend.append('se_nombre', formData.se_nombre.trim());
            }

            // Hacer la petición
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/actualizar-seccion/${seccionId}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            if (!response.ok) {
                const text = await response.text();
                
                try {
                    const data = JSON.parse(text);
                    Swal.fire({
                        title: 'Error al actualizar', 
                        text: data.error || 'Ocurrió un error en el servidor', 
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError(data.message || 'Error al actualizar la sección');
                } catch (parseError) {
                    console.error('Respuesta del servidor no es JSON válido:', text);
                    Swal.fire({
                        title: 'Error del servidor', 
                        text: 'Respuesta no válida del servidor', 
                        icon: 'error',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError('Error del servidor');
                }
                return;
            }
            
            Swal.fire({
                title: '¡Sección actualizada!',
                text: 'La sección se ha actualizado correctamente',
                icon: 'success',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#242b57',
                customClass: {
                    popup: 'popupbonito',
                },
                timer: 3000,
            }).then(() => {
                onSeccionUpdated(); 
                onBack(); // Volver a la vista principal
            });
            
        } catch (error) {
            console.error('Error de conexión:', error);
            Swal.fire({
                title: 'Error de conexión', 
                text: 'No se pudo conectar con el servidor', 
                icon: 'error',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#242b57',
                customClass: {
                    popup: 'popupbonito',
                },
            });
            setError('Error de conexión al actualizar la sección');
        } finally {
            setSaving(false);
        }
    };
    
    const getTipoTexto = () => {
        switch (tipoArchivo) {
            case 'URL':
                return 'URL de Presentación';
            case 'Video':
                return 'Video de Drive';
            case 'PDF':
                return 'Presentación PDF';
            case 'Ejercicio':
                return 'PDF Descargable';
            default:
                return 'Nueva Sección';
        }
    };

    const getPlaceholderUrl = () => {
        switch (tipoArchivo) {
            case 'URL':
                return 'https://ejemplo.com/presentacion';
            case 'Video':
                return 'https://drive.google.com/file/d/...';
            default:
                return 'https://ejemplo.com';
        }
    };


    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                    <p className={styles.loadingText}>Cargando sección...</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.formContainerPaso}>
            <div className={styles.headerSection}>
                <button className={styles.btnBack} onClick={onBack}>
                    <FaArrowLeft className={styles.flechaSeccionVolver} />
                    Volver al paso 
                </button>
                <h1 className={styles.titulo}>Editar {getTipoTexto()} </h1>
            </div>
            
            {/* Contenido principal */}
            <form onSubmit={handleSubmit} className={styles.pasoForm}>
                    <div className={styles.formBody}>
                        <div className={styles.formSection}>
                            <h3>Información de la sección</h3>
                            <div className={styles.formEdit}>
                                <label htmlFor="se_nombre">Título de la sección</label>
                                <input
                                    type="text"
                                    id="se_nombre"
                                    name="se_nombre"
                                    value={formData.se_nombre}
                                    onChange={handleInputChange}
                                    placeholder="Ej. Aprendizajes de mí"
                                    required
                                />
                            </div>

                            <div className={styles.formEdit}>
                                <label htmlFor="se_descripcion">Descripción</label>
                                <textarea
                                    id="se_descripcion"
                                    name="se_descripcion"
                                    value={formData.se_descripcion}
                                    onChange={handleInputChange}
                                    placeholder="Describe el contenido de esta sección"
                                    rows={4}
                                    required
                                />

                            </div>
                        </div>

                        <div className={styles.formSection}>
                            <h3>Diseño de Sección</h3>
                            {(tipoArchivo === 'URL' || tipoArchivo === 'Video') && (
                                <div className={styles.formEdit}>
                                    <label htmlFor="se_url">
                                        {tipoArchivo === 'Video' ? 'URL del video ' : 'URL del enlace '}
                                    </label>
                                    <input
                                        type="url"
                                        id="se_url"
                                        name="se_url"
                                        value={formData.se_url}
                                        onChange={handleInputChange}
                                        placeholder={getPlaceholderUrl()}
                                        required
                                    />
                                    {errors.se_url && <span className={styles.errorSeccion}>{errors.se_url}</span>}
                                </div>
                            )}

                            {(tipoArchivo === 'PDF' || tipoArchivo === 'Ejercicio') && (
                                <div className={styles.formEdit}>
                                    <label htmlFor="se_archivo">
                                        {tipoArchivo === 'PDF' ? 'Selecciona un archivo PDF ' : 'Subir archivo '}
                                    </label>
                                    <input
                                        type="file"
                                        id="se_archivo"
                                        name="se_archivo"
                                        onChange={handleFileChange}
                                        accept={tipoArchivo === 'PDF' ? '.pdf' : '*'}
                                    />
                                    {formData.se_archivo && (
                                        <p className="file-info">
                                            Archivo seleccionado: {
                                            typeof formData.se_archivo === 'object' && formData.se_archivo.name 
                                                ? formData.se_archivo.name 
                                                : formData.se_archivo
                                        }
                                        </p>
                                    )}
                                    {errors.se_archivo && <span className={styles.errorSeccion}>{errors.se_archivo}</span>}
                                </div>
                            )}

                            <div className={styles.formEdit}>
                                    <select onChange={handleIconSelect}>
                                        <option value="">Selecciona una opción</option>
                                        {images.map((img, index) => (
                                            <option key={index} value={index}>{img.label}</option>
                                        ))}
                                    </select>

                                    {formData.se_icono && (
    <div style={{ marginTop: '10px' }}>
        <img
            src={ selected !== null && images[selected] 
            ? images[selected].src
            : `/images/misc/${formData.se_icono}`
            }
            alt="Icono"
            style={{ width: '100%' }}
        />
    </div>
)}
                            </div>

                        </div>                        
                    </div>

                    <div className={styles.formActions}>
                        <button 
                            type="submit" 
                            className={styles.btnSubmit}
                        >
                            Confirmar
                        </button>
                    </div>
                </form>
            </div>
    );
};

export default EditarSeccion;